import { isEmpty, orderBy } from 'lodash-es'
import { type ColumnDef } from '@tanstack/table-core'

import type { LaunchDarklyEnv, CanvasManagerTableColumns } from '@lib/types/launchDarkly.types'

export function getVisibleColumns(
  visibilityAndSortingConfiguration: LaunchDarklyEnv['canvas_manager_table_columns'],
  columns: ColumnDef<Record<string, any>, any>[],
  view?: keyof CanvasManagerTableColumns,
) {
  if (isEmpty(visibilityAndSortingConfiguration) || !view) return columns

  const columnsVisibility = (visibilityAndSortingConfiguration as CanvasManagerTableColumns)[view]

  return orderBy(
    columns.filter((column) => !columnsVisibility?.hide.includes(column.id ?? '')),
    (column) => {
      const index = columnsVisibility?.order.indexOf(column.id ?? '')
      return index === -1 ? Infinity : index
    },
    'asc',
  )
}
